import PropTypes from 'prop-types'
import { reduce } from 'lodash-es'
import TimetoastPropTypes from '@constants/timetoast_prop_types.js'
import { looksLikeSerializableError } from '@utils/serializable_error.ts'

// Takes an error and tries to extract something useful to display
// Error can be a wide range of object types
// - a simple string
// - an array of JSON::API errors (potentially without a 'source', i.e. a generic/base error)
// - an object with keys for each property (and array of errors for each property)
// - a serializable rejection error (with status, message and fields properties)
const BaseErrorMessages = ({ error }) => {
  let errorMessage = null
  let errorItems = []
  if (error && typeof error === 'string') {
    // just a string, likely a generic error (e.g. a generic 500 error)
    errorMessage = error
  } else if (error && Array.isArray(error)) {
    // an array of errors. Pick out any generic errors (without a source)
    errorItems = reduce(
      error,
      (acc, err) => {
        if (!err.source) {
          acc.push(<li key={err.detail}>{err.detail}</li>)
        }
        return acc
      },
      []
    )
  } else if (error && typeof error === 'object') {
    // an object with keys for each property (and array of errors for each property)
    // lets just pick out the generic/base errors
    if (error.hasOwnProperty('base')) {
      // (Rails) errors on base object
      errorItems = reduce(
        error.base,
        (acc, errMessage) => {
          acc.push(<li key={errMessage}>{errMessage}</li>)
          return acc
        },
        []
      )
    } else if (looksLikeSerializableError(error)) {
      // looks like a serializable rejection error with a status, message and perhaps fieldErrors (which we'll deal with separately)
      // display the error message if status code makes sense to display as a base error
      if (error.status) {
        switch (error.status) {
          case 401: // unauthorized
          case 403: // forbidden
          case 404: // not found
          case 408: // request time out
          case 500: // internal server error
          case 502: // bad gateway
          case 503: // service unavailable
          case 504: // gateway timeout
            errorMessage = error.message || 'An unknown error occurred'
            break
        }
      }
    }
  }
  if (errorMessage || errorItems.length > 0) {
    return (
      <div className="error-explanation p">
        {errorMessage}
        {errorItems.length > 0 && <ul>{errorItems}</ul>}
      </div>
    )
  }
  return null
}
BaseErrorMessages.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    TimetoastPropTypes.serializableError,
  ]),
}

export default BaseErrorMessages
